import React, {useState} from "react";
import ReactDOM from 'react-dom';

export const OutsideToastsComponent = () => {
  const [ids, setIds] = useState([]);
  const onAddClick = e => {
    e.stopPropagation();
    setIds(ids => [...ids, new Date().getTime()]);
  };

  const toastList = ids.map(id => (
    <div key={id}>
      Toast with id: {id}
      <br />
      <button
        onClick={e => {
          e.stopPropagation();
          setIds(ids => ids.filter(el => el !== id));
        }}
      >
        Remove me
      </button>
    </div>
  ));
  return ReactDOM.createPortal(
    <>
      <br />
      <button onClick={onAddClick}>
        Add toast
      </button>
      {toastList}
    </>,
    document.querySelector('#outside-root'),
  );
};
